import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classPrivateFieldGet from "@babel/runtime/helpers/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime/helpers/classPrivateFieldSet";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _classPrivateMethodGet(receiver, privateSet, fn) { if (!privateSet.has(receiver)) { throw new TypeError("attempted to get private field on non-instance"); } return fn; }

/*
 * Copyright 2023 New Relic Corporation. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * @file Primes the Session Replay feature for lazy loading.
 */
import { handle } from '../../../common/event-emitter/handle';
import { DEFAULT_KEY, MODE, PREFIX } from '../../../common/session/constants';
import { InstrumentBase } from '../../utils/instrument-base';
import { hasReplayPrerequisite, isPreloadAllowed } from '../shared/utils';
import { FEATURE_NAME, SR_EVENT_EMITTER_TYPES, TRIGGERS } from '../constants';

var _mode = /*#__PURE__*/new WeakMap();

var _agentRef = /*#__PURE__*/new WeakMap();

var _canPreloadRecorder = /*#__PURE__*/new WeakSet();

var _alreadyStarted = /*#__PURE__*/new WeakMap();

var _preloadStartRecording = /*#__PURE__*/new WeakSet();

var _apiStartOrRestartReplay = /*#__PURE__*/new WeakSet();

export var Instrument = /*#__PURE__*/function (_InstrumentBase) {
  _inherits(Instrument, _InstrumentBase);

  var _super = _createSuper(Instrument);

  function Instrument(agentRef) {
    var _this;

    var auto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    _classCallCheck(this, Instrument);

    _this = _super.call(this, agentRef, FEATURE_NAME, auto);

    _apiStartOrRestartReplay.add(_assertThisInitialized(_this));

    _preloadStartRecording.add(_assertThisInitialized(_this));

    _canPreloadRecorder.add(_assertThisInitialized(_this));

    _mode.set(_assertThisInitialized(_this), {
      writable: true,
      value: void 0
    });

    _agentRef.set(_assertThisInitialized(_this), {
      writable: true,
      value: void 0
    });

    _alreadyStarted.set(_assertThisInitialized(_this), {
      writable: true,
      value: false
    });

    var _session;

    _this.replayRunning = false;

    _classPrivateFieldSet(_assertThisInitialized(_this), _agentRef, agentRef);

    try {
      _session = JSON.parse(localStorage.getItem("".concat(PREFIX, "_").concat(DEFAULT_KEY)));
    } catch (err) {}

    if (hasReplayPrerequisite(agentRef.agentIdentifier)) {
      _this.ee.on(SR_EVENT_EMITTER_TYPES.RECORD, function () {
        return _classPrivateMethodGet(_assertThisInitialized(_this), _apiStartOrRestartReplay, _apiStartOrRestartReplay2).call(_assertThisInitialized(_this));
      });
    }

    if (_classPrivateMethodGet(_assertThisInitialized(_this), _canPreloadRecorder, _canPreloadRecorder2).call(_assertThisInitialized(_this), _session)) {
      var _session2;

      _classPrivateFieldSet(_assertThisInitialized(_this), _mode, (_session2 = _session) === null || _session2 === void 0 ? void 0 : _session2.sessionReplayMode);

      _classPrivateMethodGet(_assertThisInitialized(_this), _preloadStartRecording, _preloadStartRecording2).call(_assertThisInitialized(_this));
    } else {
      _this.importAggregator(agentRef);
    }
    /** If the recorder is running, we can pass error events on to the agg to help it switch to full mode later */


    _this.ee.on('err', function (e) {
      if (_this.replayRunning) {
        _this.errorNoticed = true;
        handle(SR_EVENT_EMITTER_TYPES.ERROR_DURING_REPLAY, [e], undefined, _this.featureName, _this.ee);
      }
    });
    /** Emitted by the recorder when it starts capturing data, used to determine if we should pass errors on to the agg */


    _this.ee.on(SR_EVENT_EMITTER_TYPES.REPLAY_RUNNING, function (isRunning) {
      _this.replayRunning = isRunning;
    });

    return _this;
  } // At this point wherein session state exists already but we haven't init SessionEntity aka verify timers.

  /**
   * This func is use for early pre-load recording prior to replay feature (agg) being loaded onto the page. It should only setup once, including if already called and in-progress.
   */

  /**
   * Called whenever startReplay API is used. That could occur any time, pre or post load.
   */


  return _createClass(Instrument);
}(InstrumentBase);

function _canPreloadRecorder2(session) {
  if (!session) {
    // this might be a new session if entity initializes: conservatively start recording if first-time config allows
    // Note: users with SR enabled, as well as these other configs enabled by-default, will be penalized by the recorder overhead EVEN IF they don't actually have or get
    // entitlement or sampling decision, or otherwise intentionally opted-in for the feature.
    return isPreloadAllowed(this.agentIdentifier);
  } else if (session.sessionReplayMode === MODE.FULL || session.sessionReplayMode === MODE.ERROR) {
    return true; // existing sessions get to continue recording, regardless of this page's configs or if it has expired (conservatively)
  } else {
    // SR mode was OFF but may potentially be turned on if session resets and configs allows the new session to have replay...
    return isPreloadAllowed(this.agentIdentifier);
  }
}

function _preloadStartRecording2(_x) {
  return _preloadStartRecording3.apply(this, arguments);
}

function _preloadStartRecording3() {
  _preloadStartRecording3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(trigger) {
    var _this$recorder, _yield$import, Recorder;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_classPrivateFieldGet(this, _alreadyStarted)) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _classPrivateFieldSet(this, _alreadyStarted, true);

            _context.prev = 3;
            _context.next = 6;
            return import(
            /* webpackChunkName: "recorder" */
            '../shared/recorder');

          case 6:
            _yield$import = _context.sent;
            Recorder = _yield$import.Recorder;
            // If startReplay() has been used by this point, we must record in full mode regardless of session preload:
            // Note: recorder starts here with w/e the mode is at this time, but this may be changed later (see #apiStartOrRestartReplay else-case)
            (_this$recorder = this.recorder) !== null && _this$recorder !== void 0 ? _this$recorder : this.recorder = new Recorder({
              mode: _classPrivateFieldGet(this, _mode),
              agentIdentifier: this.agentIdentifier,
              trigger: trigger,
              ee: this.ee
            });
            this.recorder.startRecording();
            this.abortHandler = this.recorder.stopRecording;
            _context.next = 15;
            break;

          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](3);

          case 15:
            this.importAggregator(_classPrivateFieldGet(this, _agentRef), {
              recorder: this.recorder,
              errorNoticed: this.errorNoticed
            });

          case 16:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 13]]);
  }));
  return _preloadStartRecording3.apply(this, arguments);
}

function _apiStartOrRestartReplay2() {
  if (this.featAggregate) {
    // post-load; there's possibly already an ongoing recording
    if (this.featAggregate.mode !== MODE.FULL) this.featAggregate.initializeRecording(MODE.FULL, true);
  } else {
    // pre-load
    _classPrivateFieldSet(this, _mode, MODE.FULL);

    _classPrivateMethodGet(this, _preloadStartRecording, _preloadStartRecording2).call(this, TRIGGERS.API); // There's a race here wherein either:
    // a. Recorder has not been initialized, and we've set the enforced mode, so we're good, or;
    // b. Record has been initialized, possibly with the "wrong" mode, so we have to correct that + restart.


    if (this.recorder && this.recorder.parent.mode !== MODE.FULL) {
      this.recorder.parent.mode = MODE.FULL;
      this.recorder.stopRecording();
      this.recorder.startRecording();
      this.abortHandler = this.recorder.stopRecording;
    }
  }
}

_defineProperty(Instrument, "featureName", FEATURE_NAME);

export var SessionReplay = Instrument;